/* Movatic WMS — Frontend | CesarFilho 932048016 */
export default function Pagination({
  page, pageSize, total, onPageChange
}: {
  page: number, pageSize: number, total: number, onPageChange: (p:number)=>void
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const prev = () => onPageChange(Math.max(1, page-1))
  const next = () => onPageChange(Math.min(totalPages, page+1))

  return (
    <div className="flex items-center gap-3 text-sm">
      <button className="navlink" onClick={prev} disabled={page<=1}>Anterior</button>
      <span>Página <b>{page}</b> de <b>{totalPages}</b></span>
      <button className="navlink" onClick={next} disabled={page>=totalPages}>Próxima</button>
    </div>
  )
}
